<template>
  <div class="team-tab container h-100">
    <div class="row h-100 text-center d-flex flex-column flex-lg-row">
      <div class="col-lg-6 pt-lg-5">
        <div class="row mb-2">
          <div class="col p-0">
            <b-button
              @click="
                $root.$emit('openTeamChat');
                btnSfx();
              "
              variant="hexagon"
              class="chat"
              ><i></i
            ></b-button>
          </div>
          <div class="col-5 p-0">
            <img
              @click="
                $emit('openInfo');
                btnSfx();
              "
              src="/images/home/teams/in-team-bg.png"
            />
          </div>
          <div class="col p-0">
            <b-button
              @click="
                openRankings();
                btnSfx();
              "
              variant="hexagon"
              class="rank"
              ><i></i
            ></b-button>
          </div>
        </div>

        <div class="d-flex mb-2">
          <div class="mx-auto d-flex">
            <a
              @click.prevent="
                $emit('openInfo');
                btnSfx();
              "
              class="px-2"
              href="#"
            >
              <i class="fas fa-info-circle"></i>
            </a>
            <b class="text-primary">
              {{ user.team.name }}
            </b>
            <a
              v-if="user.teamRole != 'OWNER'"
              @click.prevent="
                openSettings();
                btnSfx();
              "
              class="px-2"
              href="#"
            >
              <i class="fas fa-gear text-primary"></i>
            </a>
          </div>
        </div>

        <div class="d-flex mb-3">
          <div class="team-top-info mx-auto d-flex">
            <ul>
              <li>
                <img src="/images/icon-trophy.png" />
                <b>{{
                  user.team.activeGameweekPoints
                    ? user.team.activeGameweekPoints.abbr()
                    : 0
                }}</b>
              </li>
              <li v-if="config.seasonEnabled">
                <img src="/images/icon-season-points.png" />
                <b>{{
                  user.team.activeSeasonPoints
                    ? user.team.activeSeasonPoints.abbr()
                    : 0
                }}</b>
              </li>
              <li>
                <img src="/images/icon-frends.png" />
                <b>{{ user.team.memberCount }}</b>
              </li>
            </ul>
            <b-button
              v-if="user.teamRole == 'OWNER'"
              @click="
                inviteUser();
                btnSfx();
              "
              variant="success"
              size="sm"
            >
              <img src="/images/icon-add-user.png" />
            </b-button>
          </div>
        </div>

        <div class="mb-3">
          <div
            v-if="periods.activeGameweek != undefined"
            v-html="
              $t('home.home_team_ref_tab_gameweek', {
                date:
                  moment
                    .utc(periods.activeGameweek.startDate)
                    .local()
                    .format('DD.MM HH:mm') +
                  ' - ' +
                  moment
                    .utc(periods.activeGameweek.endDate)
                    .local()
                    .format('DD.MM HH:mm'),
              })
            "
          ></div>
          <div
            v-if="periods.activeSeason != undefined && config.seasonEnabled"
            v-html="
              $t('home.home_team_ref_tab_season', {
                date:
                  moment
                    .utc(periods.activeSeason.startDate)
                    .local()
                    .format('DD.MM HH:mm') +
                  ' - ' +
                  moment
                    .utc(periods.activeSeason.endDate)
                    .local()
                    .format('DD.MM HH:mm'),
              })
            "
          ></div>
          <div
            v-if="
              periods.activeGameweek == undefined &&
              periods.activeSeason == undefined
            "
          >
            {{ $t("home.home_team_ref_tab_gameweek_empty") }}
          </div>
        </div>
      </div>
      <div class="col-lg-6 flex-fill pt-lg-3 pb-lg-3">
        <b-tabs
          v-model="currentTab"
          content-class="h-100 relative"
          fill
          @activate-tab="tabSet"
        >
          <b-tab :title="$t('home.home_team_ref_tab_members')">
            <ul v-if="membersData.members.length > 0" class="team-members-list">
              <team-member-list-item
                v-for="(m, index) in membersData.members"
                :key="m.user.id"
                :member="m"
                :order="index + 1"
                @openSettings="openSettings"
              ></team-member-list-item>
              <li
                v-if="
                  membersData.unknownMemberGameweekPoints ||
                  membersData.unknownMemberSeasonPoints
                "
                key="unknown"
              >
                <h5 class="mb-0">
                  <b>{{ $t("team.member_list_item_unknown") }}</b>
                </h5>
                <div class="team-members-list__right ml-auto">
                  <span class="gameweek">
                    <img src="/images/icon-trophy.png" />
                    <b>{{
                      membersData.unknownMemberGameweekPoints
                        ? membersData.unknownMemberGameweekPoints.abbr()
                        : 0
                    }}</b>
                  </span>
                  <span v-if="config.seasonEnabled" class="season">
                    <img src="/images/icon-season-points.png" />
                    <b>{{
                      membersData.unknownMemberSeasonPoints
                        ? membersData.unknownMemberSeasonPoints.abbr()
                        : 0
                    }}</b>
                  </span>
                  <div
                    v-if="
                      user.teamRole != undefined && user.teamRole == 'OWNER'
                    "
                    class="settings"
                  ></div>
                </div>
              </li>
            </ul>
          </b-tab>

          <b-tab
            v-if="user.teamRole == 'OWNER'"
            :title="$t('home.home_team_ref_tab_requests')"
            id="homeTeamRequests"
          >
            <ul v-if="requests.length > 0" class="team-requests-list">
              <li v-for="r in requests" :key="r.id">
                <img
                  :src="
                    r.applicant.avatarUrl != undefined
                      ? r.applicant.avatarUrl
                      : '/images/male-default.png'
                  "
                  alt="User image"
                />
                <h5 class="mb-0">
                  <b>{{ r.applicant.username }}</b>
                </h5>
                <div class="team-requests-list__right ml-auto">
                  <b-button
                    @click="
                      denyRequest(r.id);
                      btnSfx();
                    "
                    variant="danger"
                    size="sm"
                    ><i class="fas fa-times"></i
                  ></b-button>
                  <b-button
                    @click="
                      approvalRequest(r.id);
                      btnSfx();
                    "
                    variant="success"
                    size="sm"
                    ><i class="fas fa-check"></i
                  ></b-button>
                </div>
              </li>
            </ul>
            <div v-else class="d-flex flex-fill p-3">
              <span
                class="text-primary m-auto"
                v-html="$t('home.home_team_ref_tab_requests_no_data')"
              ></span>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>
    <team-settings-popup
      ref="teamSettings"
      @updateMembers="loadMembers"
    ></team-settings-popup>
    <team-invite-user-popup ref="teamInviteUser"></team-invite-user-popup>
    <team-rankings-popup ref="teamRankings"></team-rankings-popup>
  </div>
</template>
<script>
import Vue from "vue";

import SettingsPopup from "./SettingsPopup.vue";
import InviteUserPopup from "./InviteUserPopup.vue";
import RankingsPopup from "./RankingsPopup.vue";
import MemberListItem from "./MemberListItem.vue";
import api from "../../api";

const InTeamTab = Vue.component("in-team-tab", {
  component: { SettingsPopup, InviteUserPopup, RankingsPopup, MemberListItem },

  props: {
    tab: 0,
  },

  data() {
    return {
      total: 0,
      membersData: { members: [] },
      requests: [],
      periods: {},
      requestsPage: 0,
      allRequestsLoaded: false,
      requestsPerPage: 40,
    };
  },

  methods: {
    btnSfx() {
      this.$store.dispatch("sound/sfx", "Button");
    },

    tabSet(tab, silent) {
      if (silent !== true) this.btnSfx();
      const $this = this;
    },

    loadMembers() {
      const $this = this;
      api
        .teamMembers(1, 100)
        .then((res) => {
          $this.membersData = res.data;
        })
        .catch((err) => {
          api.baseErrorHendler(err);
        });
    },

    loadCompetitionPeriods() {
      const $this = this;
      api
        .competitionPeriods()
        .then((res) => {
          $this.periods = res.data;
        })
        .catch((err) => {
          api.baseErrorHendler(err);
        });
    },

    loadRequests(p) {
      const $this = this;
      let page = 1;

      // page
      if (p != undefined) page = p;
      else page = this.requestsPage + 1;

      // all loaded
      if (page != 1 && this.allRequestsLoaded == true) return;

      // request
      api
        .teamRequests(this.user.team.id, page, this.requestsPerPage)
        .then((res) => {
          $this.requestsPage = page;
          $this.allRequestsLoaded = res.data.length < this.requestsPerPage;

          if (page == 1) {
            $this.requests = res.data;
            $this.requestsSetOnScroll();
          } else $this.requests.concat(res.data);
        })
        .catch((err) => {
          api.baseErrorHendler(err);
        });
    },

    requestsSetOnScroll() {
      const listElm = document.getElementById("homeTeamRequests");
      if (listElm == undefined) return;

      listElm.addEventListener("scroll", (e) => {
        let bottom =
          Math.abs(
            listElm.scrollHeight - (listElm.scrollTop + listElm.clientHeight)
          ) < 1;
        if (bottom) {
          this.loadRequests(this.requestsPage + 1);
        }
      });
    },

    approvalRequest(id) {
      const $this = this;
      api
        .teamApprovalRequests(id)
        .then((res) => {
          $this.requests = $this.requests.filter((x) => x.id != id);
          $this.$store.dispatch("auth/getMe");
          $this.loadMembers();
        })
        .catch((err) => {
          api.baseErrorHendler(err);
        });
    },

    denyRequest(id) {
      const $this = this;
      api
        .teamDenyRequests(id)
        .then((res) => {
          $this.requests = $this.requests.filter((x) => x.id != id);
          $this.$store.dispatch("auth/getMe");
          $this.loadMembers();
        })
        .catch((err) => {
          api.baseErrorHendler(err);
        });
    },

    openSettings(user, teamRole) {
      this.$refs.teamSettings.show(user, teamRole);
    },

    openRankings() {
      this.$refs.teamRankings.show();
    },

    inviteUser() {
      this.$refs.teamInviteUser.show();
    },
  },

  computed: {
    config() {
      return this.$store.state.config.data;
    },
    user() {
      return this.$store.state.auth.user;
    },
  },

  created() {
    const $this = this;
    this.currentTab = this.tab;
    this.tabSet(this.currentTab, true);

    this.loadMembers();
    this.loadCompetitionPeriods();

    if (this.user.teamRole == "OWNER") this.loadRequests();
  },

  beforeDestroy() {
    document.getElementById("loader").classList.remove("show");
  },

  watch: {
    tab() {
      this.currentTab = this.tab;
    },
  },
});

export default InTeamTab;
</script>
